<div class="admin admin-page admin-page-externalpage">

  <app-loader *ngIf="initalLoad"></app-loader>

  <fieldset [ngClass]="{'d-none' : initalLoad}" [disabled]="isLoading || isProcessing">

    <div class="page-header d-flex align-items-start">
      <h2 class="page-title text-left">
        {{(isUpdate ? 'Edit' : 'Add') | translate}}: {{externalpageService.getTypeName(pageType) | translate}}
        <small *ngIf="!isUpdate && isDuplicateMode()" class="text-muted ml-2">(Duplicated)</small>
      </h2>

      <div class="btn-toolbar ml-auto mr-0">
        <a class="btn btn-secondary mr-3" [routerLink]="getPathOverviewByPageType(pageType)">
          <fa-icon [icon]="faChevronLeft"></fa-icon> {{'Back' | translate}}
        </a>

        <!-- Add duplicate button for existing events -->
        <button *ngIf="isUpdate && pageType === externalpageTypes.Event" class="btn btn-info mr-3" (click)="duplicateCurrentEvent()" [disabled]="isProcessing">
          <fa-icon [icon]="faCopy"></fa-icon> {{'Duplicate' | translate}}
        </button>

        <button *ngIf="isUpdate" class="btn btn-danger mr-3" (click)="Delete()" [disabled]="isProcessing">
          <fa-icon [icon]="faTimes"></fa-icon> {{'Delete' | translate}}
        </button>

        <a *ngIf="isUpdate" class="btn btn-outline-secondary ml-auto mr-3" target="_blank" [href]="getPreviewLink()">
          {{'View' | translate}} / {{'Preview' | translate}}
        </a>

        <button class="btn btn-primary" (click)="Save()" [disabled]="isProcessing">
          <fa-icon [icon]="faSave"></fa-icon> {{'Save' | translate}}
          <fa-icon [icon]="faSpinner" animation="spin" *ngIf="isProcessing"></fa-icon>
        </button>
      </div>
    </div>

    <div class="page-body">

      <ul class="nav nav-tabs mt-3">
        <li class="nav-item">
          <a class="nav-link cursor-pointer" [class.active]="activeEditorTab === 'nl'" (click)="activeEditorTab = 'nl'">
            <img class="img img-16 mr-1" [src]="'/assets/img/icons/locale/flag/nl.png'"> NL
          </a>
        </li>
        <li>
          <a class="nav-link cursor-pointer" [class.active]="activeEditorTab === 'en'" (click)="activeEditorTab = 'en'">
            <img class="img img-16 mr-1" [src]="'/assets/img/icons/locale/flag/en.png'"> EN
          </a>
        </li>
        <li>
          <a class="nav-link cursor-pointer" [class.active]="activeEditorTab === 'de'" (click)="activeEditorTab = 'de'">
            <img class="img img-16 mr-1" [src]="'/assets/img/icons/locale/flag/de.png'"> DE
          </a>
        </li>
        <li>
          <a class="nav-link cursor-pointer" [class.active]="activeEditorTab === 'fr'" (click)="activeEditorTab = 'fr'">
            <img class="img img-16 mr-1" [src]="'/assets/img/icons/locale/flag/fr.png'"> FR
          </a>
        </li>
        <li>
          <a class="nav-link cursor-pointer" [class.active]="activeEditorTab === 'pt'" (click)="activeEditorTab = 'pt'">
            <img class="img img-16 mr-1" [src]="'/assets/img/icons/locale/flag/pt.png'"> BR
          </a>
        </li>

      </ul>

      <div class="row">

        <div class="col-12 col-md-8 col-lg-8 entity-main">

          <div class="tab-content">

            <!-- NL language -->
            <div id="tab-externalpage-editor-nl" class="tab-pane" [class.active]="activeEditorTab === 'nl'" [class.d-none]="activeEditorTab !== 'nl'">

              <div class="form-group mt-3">
                <label>{{'Title' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.title" (change)="onTitleChange($event)" />
              </div>

              <div class="form-group">
                <label>{{'Content' | translate}}</label>
                <ckeditor [config]="editorConfig" [editor]="Editor" class="editor_xl" [(ngModel)]="entity.content"></ckeditor>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta description' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaDescription"></textarea>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta keywords' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaKeywords"></textarea>
              </div>

            </div>

            <!-- EN language -->
            <div id="tab-externalpage-editor-en" class="tab-pane" [class.active]="activeEditorTab === 'en'" [class.d-none]="activeEditorTab !== 'en'">

              <div class="form-group mt-3">
                <label>{{'Title' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.titleEn" />
              </div>

              <div class="form-group">
                <label>{{'Content' | translate}}</label>
                <ckeditor [config]="editorConfig" [editor]="Editor" class="editor_xl" [(ngModel)]="entity.contentEn"></ckeditor>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta description' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaDescriptionEn"></textarea>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta keywords' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaKeywordsEn"></textarea>
              </div>

            </div>

            <!-- DE language -->
            <div id="tab-externalpage-editor-de" class="tab-pane" [class.active]="activeEditorTab === 'de'" [class.d-none]="activeEditorTab !== 'de'">

              <div class="form-group mt-3">
                <label>{{'Title' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.titleDe" />
              </div>

              <div class="form-group">
                <label>{{'Content' | translate}}</label>
                <ckeditor [config]="editorConfig" [editor]="Editor" class="editor_xl" [(ngModel)]="entity.contentDe"></ckeditor>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta description' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaDescriptionDe"></textarea>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta keywords' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaKeywordsDe"></textarea>
              </div>

            </div>

            <!-- FR language -->
            <div id="tab-externalpage-editor-fr" class="tab-pane" [class.active]="activeEditorTab === 'fr'" [class.d-none]="activeEditorTab !== 'fr'">

              <div class="form-group mt-3">
                <label>{{'Title' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.titleFr" />
              </div>

              <div class="form-group">
                <label>{{'Content' | translate}}</label>
                <ckeditor [config]="editorConfig" [editor]="Editor" class="editor_xl" [(ngModel)]="entity.contentFr"></ckeditor>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta description' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaDescriptionFr"></textarea>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta keywords' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaKeywordsFr"></textarea>
              </div>

            </div>

            <!-- PT language -->
            <div id="tab-externalpage-editor-pt" class="tab-pane" [class.active]="activeEditorTab === 'pt'" [class.d-none]="activeEditorTab !== 'pt'">

              <div class="form-group mt-3">
                <label>{{'Title' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.titlePt" />
              </div>

              <div class="form-group">
                <label>{{'Content' | translate}}</label>
                <ckeditor [config]="editorConfig" [editor]="Editor" class="editor_xl" [(ngModel)]="entity.contentPt"></ckeditor>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta description' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaDescriptionPt"></textarea>
              </div>

              <div class="form-group mt-3">
                <label>{{'Meta keywords' | translate}}</label>
                <textarea rows="4" class="form-control" [(ngModel)]="entity.metaKeywordsPt"></textarea>
              </div>

            </div>

          </div>

          <!-- content images -->
          <div class="form-group" [ngClass]="{'d-none' : !id ? true : false}">
            <label>{{'Content images' | translate}}</label>

            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" (change)="onFileImageContentChange($event)" [(ngModel)]="fileContentImage" id="fileContentImage">
                <label class="custom-file-label" for="fileContentImage" #inputFileContentImage [attr.data-browse]="'Select file' | translate">{{'Upload a new photo' | translate}}</label>
              </div>
              <div class="input-group-append">
                <button [disabled]="isProcessingContentImage || isProcessing" class="btn btn-primary ml-auto" (click)="addImage(id, externalpageImageTypes.ContentImage)">
                  <fa-icon *ngIf="isProcessingContentImage" [icon]="faSpinner" animation="spin"></fa-icon>
                  {{'Upload' | translate}}
                </button>
              </div>
            </div>

            <div class="row mt-3" *ngIf="imageDataContent.length > 0">
              <div *ngFor="let contentImage of imageDataContent" class="col-2">
                <div class="btn-toolbar position-absolute mr-0">
                  <button class="btn btn-danger btn-sm" (click)="deleteImage(id, contentImage.id)">
                    <fa-icon [icon]="faTimes"></fa-icon>
                  </button>
                  <button class="btn btn-secondary btn-sm" (click)="copyImageUri(contentImage.imageUri)">
                    <fa-icon [icon]="faLink"></fa-icon>
                  </button>
                </div>

                <span class="image-preview-wrapper">
                  <img [src]="contentImage.imageUri" class="img img-fluid img-thumbnail image image-main image-preview" />
                </span>
              </div>
            </div>
          </div>

          <!-- school data -->
          <span *ngIf="entity.type == externalpageTypes.School && entity.address">

            <h3>{{'Address' | translate}}</h3>

            <div class="row">

              <div class="col-sm-8">
                <div class="form-group">
                  <label>{{'Street' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.street" />
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label>{{'No.' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.number" />
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label>{{'Addition' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.numberSuffix" />
                </div>
              </div>

              <div class="col-sm-8">
                <div class="form-group">
                  <label>{{'City' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.city" />
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label>{{'Postal code' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.postalCode" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label>{{'Country' | translate}}</label>
                  <select class="form-control" [(ngModel)]="entity.address.country">
                    <option *ngFor="let option of locale.availableCountries()" [value]="option.code">{{option.name}}</option>
                  </select>
                </div>
              </div>

            </div>

          </span>



        </div>

        <div class="col-12 col-md-4 col-lg-4 entity-sidebar">

          <!-- publication -->
          <!-- In admin-externalpage.component.html, update the permalink section in the sidebar -->

          <!-- publication -->
          <div class="card mt-5">
            <div class="card-header">
              <h5 class="card-title mb-0">{{'Publication' | translate}}</h5>
            </div>
            <div class="card-body">

              <div class="row">
                <div class="col-8">

                  <div class="form-group">
                    <label>{{'Status' | translate}}</label>
                    <select class="form-control" [(ngModel)]="entity.status">
                      <option *ngFor="let status of externalPageStatuses" [value]="status.value">
                        {{status.name | translate}}
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>{{'Publication date' | translate}}</label>
                    <input ngbDatepicker class="form-control" [(ngModel)]="entity.publicationDate" (click)="publicationDate.toggle()" #publicationDate="ngbDatepicker" />
                  </div>

                </div>
                <div class="col-4">

                  <div class="form-group">
                    <label>{{'Region' | translate}}</label>
                    <app-core-selector [type]="'checkbox'" [filterOptions]="regions" [selectorValue]="'id'" [selectorLabel]="'name'" [(ngModel)]="entity.regions"></app-core-selector>
                  </div>

                </div>
              </div>

              <!-- Root level toggle (ONLY FOR EVENTS) -->
              <div class="form-group" *ngIf="entity.type === externalpageTypes.Event">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="isRootLevel" (change)="onRootLevelToggle()" id="rootLevelToggle">
                  <label class="form-check-label" for="rootLevelToggle">
                    {{'Root level event' | translate}}
                  </label>
                </div>
                <small class="form-text text-muted">
                  {{'If enabled, event will be accessible directly from domain root (e.g., domain.com/special-event)' | translate}}
                </small>
              </div>

              <!-- permalink -->
              <div class="form-group">
                <label>{{'Permalink' | translate}}</label>
                <div class="input-group">
                  <div class="input-group-prepend" *ngIf="isRootLevel && entity.type === externalpageTypes.Event">
                    <span class="input-group-text">~</span>
                  </div>
                  <input type="text" class="form-control" [ngClass]="{'is-invalid': permalinkValidationError}" [(ngModel)]="displayPermalink" (blur)="onPermalinkChange()" (input)="onPermalinkChange()" />
                </div>

                <!-- Validation error message -->
                <div class="invalid-feedback d-block" *ngIf="permalinkValidationError">
                  {{permalinkValidationError}}
                </div>

                <!-- Suggestions -->
                <div *ngIf="permalinkSuggestions.length > 0" class="mt-2">
                  <small class="text-muted">{{'Suggestions' | translate}}:</small>
                  <div class="mt-1">
                    <button *ngFor="let suggestion of permalinkSuggestions" type="button" class="btn btn-sm btn-outline-secondary mr-1" (click)="applySuggestion(suggestion)">
                      {{suggestion}}
                    </button>
                  </div>
                </div>

                <!-- Preview URL -->
                <small class="form-text text-muted" *ngIf="!permalinkValidationError">
                  {{'Page will be accessible at' | translate}}: {{getPreviewUrl()}}
                </small>
              </div>

            </div>
          </div>

          <!-- image data -->
          <div class="card mt-3" [ngClass]="{'d-none' : !id ? true : false}">
            <div class="card-header">
              <h5 class="card-title mb-0">{{'Images' | translate}}</h5>
            </div>
            <div class="card-body">

              <!-- main image -->
              <div class="form-group">
                <label>{{'Main image' | translate}}</label>
                <div class="row mb-3">
                  <div *ngIf="imageDataMain.imageUri" class="col-12">
                    <div class="btn-toolbar position-absolute mr-0">
                      <button class="btn btn-danger btn-sm" (click)="deleteImage(id, imageDataMain.id)">
                        <fa-icon [icon]="faTimes"></fa-icon>
                      </button>
                      <button class="btn btn-secondary btn-sm" (click)="copyImageUri(imageDataMain.imageUri)">
                        <fa-icon [icon]="faLink"></fa-icon>
                      </button>
                    </div>

                    <span class="image-preview-wrapper">
                      <img [src]="imageDataMain.imageUri" class="img img-fluid img-thumbnail image image-main image-preview" />
                    </span>
                  </div>
                </div>

                <div class="input-group">

                  <div class="custom-file">
                    <input type="file" class="custom-file-input" (change)="onFileImageChange($event)" [(ngModel)]="fileMainImage" id="fileMainImage">
                    <label class="custom-file-label" for="fileMainImage" #inputFileMainImage [attr.data-browse]="'Select file' | translate">{{'Upload a new photo' | translate}}</label>
                  </div>
                  <div class="input-group-append">
                    <button [disabled]="isProcessingMainImage || isProcessing" class="btn btn-primary ml-auto" (click)="addImage(id, externalpageImageTypes.MainImage)">
                      <fa-icon *ngIf="isProcessingMainImage" [icon]="faSpinner" animation="spin"></fa-icon>
                      {{'Upload' | translate}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- gallery images -->
              <div class="form-group">
                <label>{{'Extra image(s)' | translate}}</label>

                <div class="input-group">

                  <div class="custom-file">
                    <input type="file" class="custom-file-input" (change)="onFileImageGalleryChange($event)" [(ngModel)]="fileGalleryImage" id="fileGalleryImage">
                    <label class="custom-file-label" for="fileGalleryImage" #inputFileGalleryImage [attr.data-browse]="'Select file' | translate">{{'Upload a new photo' | translate}}</label>
                  </div>
                  <div class="input-group-append">
                    <button [disabled]="isProcessingGalleryImage || isProcessing" class="btn btn-primary ml-auto" (click)="addImage(id, externalpageImageTypes.GalleryImage)">
                      <fa-icon *ngIf="isProcessingGalleryImage" [icon]="faSpinner" animation="spin"></fa-icon>
                      {{'Upload' | translate}}
                    </button>
                  </div>
                </div>

                <div class="row mt-3" *ngIf="imageDataGallery.length > 0">
                  <div *ngFor="let galleryImage of imageDataGallery" class="col-4">
                    <div class="btn-toolbar position-absolute mr-0">
                      <button class="btn btn-danger btn-sm" (click)="deleteImage(id, galleryImage.id)">
                        <fa-icon [icon]="faTimes"></fa-icon>
                      </button>
                      <button class="btn btn-secondary btn-sm" (click)="copyImageUri(galleryImage.imageUri)">
                        <fa-icon [icon]="faLink"></fa-icon>
                      </button>
                    </div>

                    <span class="image-preview-wrapper">
                      <img [src]="galleryImage.imageUri" class="img img-fluid img-thumbnail image image-main image-preview" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- project properties -->
          <div class="card mt-3" *ngIf="entity.type == externalpageTypes.Project">

            <div class="card-header">
              <h5 class="card-title mb-0">{{'Project' | translate}}</h5>
            </div>

            <div class="card-body">

              <div class="form-group">
                <label>{{'Meet day' | translate}}</label>
                <select class="form-control" [(ngModel)]="entity.meetDayId">
                  <option></option>
                  <option [value]="meetDay['id']" *ngFor="let meetDay of meetDays">{{ meetDay.name }}</option>
                </select>
              </div>

            </div>

          </div>

          <!-- event properties -->
          <div class="card mt-3" *ngIf="entity.type == externalpageTypes.Event">

            <div class="card-header">
              <h5 class="card-title mb-0">{{'Event' | translate}}</h5>
            </div>

            <div class="card-body">

              <div class="form-group">
                <label>{{'Event date' | translate}}</label>
                <input ngbDatepicker class="form-control" [(ngModel)]="entity.eventDate" (click)="eventDate.toggle()" #eventDate="ngbDatepicker" />
              </div>

              <div class="form-group">
                <label>{{'Event period' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.eventPeriodDescription" />
              </div>

              <div class="form-group">
                <label>{{'Meet day' | translate}}</label>
                <select class="form-control" [(ngModel)]="entity.meetDayId">
                  <option></option>
                  <option [value]="meetDay['id']" *ngFor="let meetDay of meetDays">{{ meetDay.name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label>{{'Target groups' | translate}}</label>
                <app-tag-selector
                  [options]="targetGroupOptions"
                  [(ngModel)]="entity.targetGroups"
                ></app-tag-selector>
              </div>

            </div>

          </div>

          <!-- video properties -->
          <div class="card mt-3" *ngIf="entity.type == externalpageTypes.Video">

            <div class="card-header">
              <h5 class="card-title mb-0">{{'Video' | translate}}</h5>
            </div>

            <div class="card-body">

              <div class="form-group">
                <label>{{'Video URL' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.videoUri" />
              </div>

            </div>

          </div>

          <!-- testimonial properties -->
          <div class="card mt-3" *ngIf="entity.type == externalpageTypes.Testimonial">

            <div class="card-header">
              <h5 class="card-title mb-0">{{'Testimonial' | translate}}</h5>
            </div>

            <div class="card-body">

              <div class="form-group">
                <label>{{'Name' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.testimonialName" />
              </div>

              <div class="form-group">
                <label>{{'Organisation' | translate}}</label>
                <input class="form-control" [(ngModel)]="entity.testimonialOrganisation" />
              </div>

              <div class="form-group">
                <label>{{'Type' | translate}}</label>
                <select class="form-control" [(ngModel)]="entity.testimonialType">
                  <option *ngFor="let type of testimonialTypes" [value]="type.value">
                    {{type.name | translate}}
                  </option>
                </select>
              </div>

            </div>

          </div>

          <!-- school properties -->
          <div class="card mt-3" *ngIf="entity.type == externalpageTypes.School">

            <div class="card-header">
              <h5 class="card-title mb-0">{{'School' | translate}}</h5>
            </div>

            <div class="card-body">

              <div class="form-group">
                <label>{{'Type' | translate}}</label>
                <select class="form-control" [(ngModel)]="entity.schoolType">
                  <option *ngFor="let type of schoolTypes | keyvalue" [value]="type['value']">{{type['value']}}</option>
                </select>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </fieldset>

</div>
